import { useState } from 'react';
import './Portfolio.css';
import { projects } from './projects';
import { Modal } from '../components/index';

function Portfolio() {
  const [currentID, setCurrentID] = useState(null);

  const handleClick = (id) => setCurrentID(id);
  const clearCurrentProject = () => setCurrentID(null);

  const projectsList = projects.map((project) => {
    return (
      <div
        key={project.id}
        onClick={() => handleClick(project.id)}
        className='portfolio-projects-frame'
      >
        <h5>{project.title}</h5>
        <div className='portfolio-projects-frame-img'>
          <img
            src={project.image}
            alt={project.title}
          ></img>
        </div>
      </div>
    );
  });

  let currentProject =
    currentID && projects.find((project) => currentID === project.id);

  return (
    <section
      id='portfolio'
      className='portfolio-container'
    >
      <p>
        <h1>Portfolio</h1>
        <span className='more'>(click on the card to find out more)</span>
      </p>
      <p>
        This is my Github Page:&nbsp;
        <a
          href='https://github.com/PacificaElise'
          target='_blank'
          rel='noreferrer'
        >
          <span className='link'>Github Page Link</span>
        </a>
      </p>
      <div className='portfolio-grid'>
        {currentProject && (
          <Modal
            onClick={clearCurrentProject}
            title={currentProject.title}
            description={currentProject.description}
            image={currentProject.image}
            url={currentProject.url}
          />
        )}
        {projectsList}
      </div>
    </section>
  );
}

export default Portfolio;
